import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const auctionAPI = createApi({
  reducerPath: "auctionAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_DEV_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().user.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getAllRoles: builder.query({
      query: () => ({
        url: `/role/getAllRoles`,
        method: "GET",
      }),
    }),

    declare: builder.mutation({
      query: (data) => ({
        url: `/auction/declare`,
        method: "POST",
        body: data,
      }),
    }),
    pickNextPlayer: builder.mutation({
      query: (data) => ({
        url: `/auction/pickNextPlayer`,
        method: "POST",
        body: data,
      }),
    }),
    bid: builder.mutation({
      query: (data) => ({
        url: `/auction/bid`,
        method: "POST",
        body: data,
      }),
    }),
    passPlayer: builder.mutation({
      query: (data) => ({
        url: `/auction/passPlayer`,
        method: "POST",
        body: data,
      }),
    }),
    sellPlayer: builder.mutation({
      query: (data) => ({
        url: `/auction/sellPlayer`,
        method: "POST",
        body: data,
      }),
    }),
    resetAuction: builder.mutation({
      query: (data) => ({
        url: `/auction/resetAuction`,
        method: "POST",
        body: data,
      }),
    }),
    reAuction: builder.mutation({
      query: (data) => ({
        url: `/auction/reAuction`,
        method: "POST",
        body: data,
      }),
    }),
    undoPlayer: builder.mutation({
      query: (data) => ({
        url: `/auction/undoPlayer`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetAllRolesQuery,
  useDeclareMutation,
  usePickNextPlayerMutation,
  usePassPlayerMutation,
  useBidMutation,
  useSellPlayerMutation,
  useResetAuctionMutation,
  useReAuctionMutation,
  useUndoPlayerMutation,
} = auctionAPI;
